<template>
  <v-card class="ps-card" flat>
    <div class="ps-card__head">
      <v-icon small>mdi-printer</v-icon>
      Print Shops
      <span class="ps-card__hint">Zuständigkeiten je Land</span>
    </div>
    <v-card-text>
      <v-data-table
        hide-default-footer
        :loading="loadingPrintShops"
        :headers="headers"
        :items="printShops"
        class="ps-table"
      >
        <template v-slot:item.printShop="{ item }">
          <span class="ps-name">{{ item.name }}</span>
        </template>
        <template v-slot:item.countries="{ item }">
          <template v-if="item.countries.length">
            <span v-for="cc in item.countries" :key="cc" class="ps-chip">
              {{ flag(cc) }} {{ cc }}
            </span>
          </template>
          <span v-else class="ps-chip ps-chip--muted">keine</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PrintShops",
  data() {
    return {
      headers: [
        { text: "Print Shop", value: "printShop" },
        { text: "Zuständig für", value: "countries" },
      ],
    };
  },
  computed: {
    ...mapGetters(["printShops", "loadingPrintShops"]),
  },
  mounted() {
    this.loadPrintShops();
  },
  methods: {
    ...mapActions(["loadPrintShops"]),
    flag(cc) {
      if (!/^[A-Z]{2}$/.test(cc)) return "";
      return String.fromCodePoint(
        ...[...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
      );
    },
  },
};
</script>

<style scoped></style>
